paper dimensions: [1]
fold [c] to top of [a]
fold [b] to top of [d]
fold [b] around [a, e]
fold [b] to top of [e]
fold [d] to top of [e]
fold [g, f] to bottom of [c, f]
fold [i, j] to bottom of [c, f]
fold [m, p] to bottom of [n, q]
fold [a] around [m, p]